import Vue from 'vue'
import KeenSlider from "keen-slider";
import { toNumber } from '~/helpers/helpers'

export default {
  data() {
    return {
      galleriaConfiguration: {
        photos: [],
        details: [],
        description: ''
      },

      isGalleryOpen: false
    }
  },

  computed: {
    getServerFormatedConfigurations() {
      if (this.hasConfigurations) {
        return this._getServerFormatedConfigurations(this.product.configurations)
      }

      return []
    },

    getListOfActiveConfigurations() {
      if (this.hasConfigurations) {
        return this._getListOfActiveConfigurations(this.product.configurations)
      }

      return []
    },

    hasConfigurations() {
      return !!this.product.configurations?.length && Array.isArray(this.product.configurations)
    },

    getGalleriaResponsiveOptions() {
      return [
        {
          breakpoint: "9999px",
          numVisible: Math.min(16, this.galleriaConfiguration.photos.length),
        },
        {
          breakpoint: "1650px",
          numVisible: Math.min(15, this.galleriaConfiguration.photos.length),
        },
        {
          breakpoint: "1580px",
          numVisible: Math.min(14, this.galleriaConfiguration.photos.length),
        },
        {
          breakpoint: "1500px",
          numVisible: Math.min(13, this.galleriaConfiguration.photos.length),
        },
        {
          breakpoint: "1366px",
          numVisible: Math.min(12, this.galleriaConfiguration.photos.length),
        },
        {
          breakpoint: "1280px",
          numVisible: Math.min(11, this.galleriaConfiguration.photos.length),
        },
        {
          breakpoint: "1150px",
          numVisible: Math.min(10, this.galleriaConfiguration.photos.length),
        },
        {
          breakpoint: "1050px",
          numVisible: Math.min(9, this.galleriaConfiguration.photos.length),
        },
        {
          breakpoint: "992px",
          numVisible: Math.min(8, this.galleriaConfiguration.photos.length),
        },
        {
          breakpoint: "880px",
          numVisible: Math.min(7, this.galleriaConfiguration.photos.length),
        },
        {
          breakpoint: "700px",
          numVisible: Math.min(6, this.galleriaConfiguration.photos.length),
        },
        {
          breakpoint: "620px",
          numVisible: Math.min(5, this.galleriaConfiguration.photos.length),
        },
        {
          breakpoint: "440px",
          numVisible: Math.min(4, this.galleriaConfiguration.photos.length),
        },
        {
          breakpoint: "400px",
          numVisible: Math.min(3, this.galleriaConfiguration.photos.length),
        },
        {
          breakpoint: "340px",
          numVisible: 2,
        },
      ];

    },

    getCleanConfigurations() {
      if (this.hasConfigurations) {
        return this._getCleanConfigurations(this.product.configurations)
      }

      return []
    },
  },

  methods: {
    getConfigurationsPrice(base, field = 'price') {
      base = Number(base);

      if (isNaN(base)) return '-'

      const calculatePrice = (configurations) => {
        configurations.forEach((configuration) => {
          configuration.items.forEach((configurationItem) => {
            if (configurationItem.active) {

              base += Number(configurationItem[field]) * toNumber(configurationItem.quan, 1);

              if (configurationItem.nested?.configurations?.length) {
                calculatePrice(configurationItem.nested.configurations);
              }
            }
          });
        });
      };

      calculatePrice(this.product.configurations);

      return base;
    },

    setActiveConfiguration(configuration) {
      this.product.configurations.forEach(conf => {
        this.$set(conf, 'active', conf.name === configuration.name)
      })

      configuration.items.forEach(configurationItem => {
        this.initPhotosSlider(configurationItem)
      })

      if (!configuration.photosRequested) {
        this.requestPhotos(configuration)
      }
    },

    getActiveConfigurationItem(configuration) {
      return configuration.items.find(configurationItem => configurationItem.active)
    },

    getConfigurationItemIsNested(configurationItem) {
      return !!configurationItem.nested?.configurations?.length
    },

    getConfigurationHasNestedItem(configuration) {
      return configuration.items.some(configurationItem => this.getConfigurationItemIsNested(configurationItem))
    },

    isNoneConfigurationSelected(configuration) {
      return this.getActiveConfigurationItem(configuration)?.id === -1
    },

    isServerConfigurationSelected(configuration) {
      const item = this.getActiveConfigurationItem(configuration)
      return !!item && item.id !== -1
    },

    isAnyConfigurationSelected(configuration) {
      return !!this.getActiveConfigurationItem(configuration)
    },

    async requestNested(configuration) {
      this.$set(configuration, 'isLoading', true)

      try {
        const data = await this.$axios.$get("configurations", {
          params: {
            id: configuration.id,
            root: false,
            // The product being configured: its TAR_AMT, not the option's, sets the tariff.
            tariffParent: (this.root || this).offer?.id
          },
        });

        this.$set(configuration, 'nested', data)

      } catch (err) {
        this.__logError(err)
      }

      this.$set(configuration, 'isLoading', false)

    },

    async requestPhotos(configuration) {
      this.$set(configuration, 'photosLoading', true)

      let id = this.product.id

      if (this.offer) id = this.offer.id

      if (!this.nested && this.root?.offer) id = this.root.offer.id

      try {
        const data = await this.$axios.$get('configurations-photos', {
          params: {
            id,
            categoryName: configuration.name
          }
        })

        if (Array.isArray(data)) {
          configuration.photosRequested = true

          data.forEach(serverConfiguration => {
            const itemConfiguration = configuration.items.find(conf => conf.id === serverConfiguration.id)

            if (itemConfiguration) {
              this.$set(itemConfiguration, 'photos', serverConfiguration.photos)
              this.initPhotosSlider(itemConfiguration)
            }
          })
        }

      } catch (err) {
        this.__logError(err)
      }

      this.$set(configuration, 'photosLoading', false)

    },

    initPhotosSlider(configurationItem) {
      this.$nextTick(() => {
        try {
          const CONTAINER = document.querySelector(`#slider-${configurationItem.id}`)

          if (CONTAINER) {
            if (configurationItem.slider) {
              configurationItem.slider.destroy()
              clearInterval(configurationItem.interval);
            }

            configurationItem.slider = new KeenSlider(CONTAINER, {
              loop: true,

              slides: {
                perView: 1,
                spacing: 0,
              },
            })

            const autoplay = (run) => {
              if (configurationItem.photos?.length < 2) return;

              clearInterval(configurationItem.interval);

              configurationItem.interval = setInterval(() => {
                if (run && configurationItem.slider) {
                  configurationItem.slider.next();
                }
              }, 3000);
            }

            CONTAINER.addEventListener("mouseover", () => {
              autoplay(false);
            });

            CONTAINER.addEventListener("mouseout", () => {
              autoplay(true);
            });

            autoplay(true);
          }
        } catch (err) {
          this.__logError(err)
        }
      })

    },

    // TODO: remove active for nested as well
    async setActiveConfigurationItem(configuration, configurationItem, parent) {
      configuration.items.forEach(confItem => {
        this.$set(confItem, 'active', confItem.id === configurationItem.id)
      })

      if (!configurationItem.nested && configurationItem.id !== -1) {
        await this.requestNested(configurationItem)
      }

      configurationItem.inited = true

      this.checkAutonext([parent], parent.index)
    },

    setGalleriaConfiguration(configuration) {
      this.galleriaConfiguration = configuration
      this.isGalleryOpen = true
    },

    async getConfigurationItemDetails(configurationItem) {
      if (!configurationItem.detailsRequested) {
        configurationItem.detailsRequested = true

        try {
          const details = await this.$axios.$get('product-details', {
            params: {
              id: configurationItem.id,
            },
          });

          this.$set(configurationItem, 'details', details)

        } catch (err) {
          this.__logError(err);
        }
      }
    },

    selectFirstConfiguration() {
      this.setActiveConfiguration(this.product.configurations[0])
    },

    selectAllConfiguration() {
      if (this.product.configurations.length) {
        this.product.configurations.forEach(configuration => {
          this.$set(configuration, 'active', true)
        })
      }
    },

    formatConfigurations() {
      if (!this.nested) {
        this.product.configurations.push({
          name: "Accessories",
          type: 'custom',
          allownone: true,
          items: []
        })
      }

      this.product.configurations.forEach((configuration, index) => {
        if (configuration.allownone || !configuration.items.length) {
          configuration.items.unshift({
            name: 'No option',
            id: -1,
            price: 0,
            msrpPrice: 0,
            tariff: 0,
            photo: null,
            intNote: []
          })
        }

        configuration.index = index
      })
    },

    getConfigurationRequiredPhotos() {
      this.product.configurations.forEach(configuration => {
        if (!configuration.photosRequested && configuration.type !== 'custom') {
          this.requestPhotos(configuration)
        }
      })
    },

    setDefaultConfigurations() {
      this.product.configurations.forEach(configuration => {
        __setDefaultConfiguration(configuration)
      })
    },

    removeConfiguration(configuration, configurationItem) {
      this.$set(configurationItem, 'nested', null)
      this.$set(configurationItem, 'active', false)

      __setDefaultConfiguration(configuration)

      // come back user to the select
      if (!configuration.allownone) {
        this.setActiveConfiguration(configuration)
      }

    },

    next(index) {
      const next = this.product.configurations[index + 1]
      this.setActiveConfiguration(next)
    },

    prev(index) {
      const prev = this.product.configurations[index - 1]
      this.setActiveConfiguration(prev)
    },

    getHasUncheckedRequiredConfigurations(configurations) {
      let hasUnchecked = false

      if (this.hasConfigurations) {
        const check = configurations => {
          configurations.forEach(configuration => {
            if (!configuration.allownone && !configuration.items.find(configurationItem => (configurationItem.active && !configurationItem.isLoading))) {
              hasUnchecked = true
            }

            configuration.items.forEach(configurationItem => {
              if (configurationItem.nested?.configurations?.length) {
                check(configurationItem.nested.configurations)
              }
            })
          })
        }

        check(configurations)
      }

      return hasUnchecked
    },

    checkAutonext(configurations, index) {
      let hasUnchecked = false

      const check = configurations => {
        configurations.forEach(configuration => {
          const active = configuration.items.find(configurationItem => (configurationItem.active && !configurationItem.isLoading))

          if (!active || !active.inited) {
            hasUnchecked = true
          }

          configuration.items.forEach(configurationItem => {
            if (configurationItem.nested?.configurations?.length) {
              check(configurationItem.nested.configurations)
            }
          })
        })
      }

      check(configurations)

      if (!hasUnchecked) {
        this.root.next(index)
      }
    },

    resetConfigurations() {
      if (this.hasConfigurations) {
        this.product.configurations.forEach(configuration => {
          configuration.items.forEach(configurationItem => {
            this.$set(configurationItem, 'nested', null)
            this.$set(configurationItem, 'active', false)
          })

          __setDefaultConfiguration(configuration)
        })

        this.setActiveConfiguration(this.product.configurations[0])
      }
    }
  }
}

const __setDefaultConfiguration = configuration => {
  const activeConfiguration = configuration.items.find(configurationItem => configurationItem.active)

  if (!activeConfiguration && configuration.allownone) {
    const defultConfigurationItem = configuration.items.find(configurationItem => configurationItem.id === -1)
    Vue.set(defultConfigurationItem, 'active', true)
  }
}